module.exports = __webpack_public_path__ + "img/js-bin.png";